import React, { useState, useEffect } from 'react';
import { Form, Select, Spin } from 'antd';
import { CreateV2fxAccountApi, GetPlansForUserApi } from '../../../api/request/client.js';
import { useNavigate, useParams } from 'react-router-dom';
import AccountCard from './AccountCard.jsx';
import LoadableButton from '../../../components/buttons/LoadableButton.jsx';
import ModalComponent from '../../../components/global/modal/ModalComponent.jsx';
import toast from 'react-hot-toast';

export default function V2fxAccount() {

  const params = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [accountTypes, setAccountTypes] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState({});
  const [liveInitialValues, setLiveInitialValues] = useState({ v2fx: null });
  const [isOpenLiveForm, setIsOpenLiveForm] = useState(false);
  const [isLiveFormLoading, setIsLiveFormLoading] = useState(false);
  const [v2fxOptions, setV2fxOptions] = useState([{ value: 20, label: '20' }, { value: 50, label: '50' }, { value: 100, label: '100' }, { value: 200, label: '200' }, { value: 300, label: '300' }, { value: 400, label: '400' }, { value: 500, label: '500' }]);

  const getPlansForUser = async () => {
    try {
      setIsLoading(true);
      let apiParams = {
        userId: params?.id,
        tradingAccountType: 0 // 0 - Live account
      }
      const { data } = await GetPlansForUserApi(apiParams);
      if (data?.success) {
        setAccountTypes(data?.data);
      }
      setIsLoading(false);
    } catch (error) { }
  }

  useEffect(() => {
    getPlansForUser();
  }, []);

  useEffect(() => {
    form.resetFields();
  }, [isOpenLiveForm]);

  const createAccount = (account) => {
    setSelectedAccount(account);
    setIsOpenLiveForm(true);
  }

  const handleLiveAccount = async (values) => {
    try {
      setIsLiveFormLoading(true);
      let apiParams = {
        userId: params?.id,
        v2fx: values?.v2fx,
        planId: selectedAccount?.planId,
        balanceDeposit: 0,
        tradingAccountType: 0, // 0 - Live Account
      }
      const { data } = await CreateV2fxAccountApi(apiParams);
      if (data?.success) {
        setIsLiveFormLoading(false);
        toast?.success(data?.message);
        navigate(`/client_details/${params?.id}`);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsLiveFormLoading(false);
    }
  }

  return (
    <div>
      <div className='border rounded p-4 lg:p-6'>
        {isLoading ? (
          <div className="flex justify-center flex-col my-[20%]">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <div >
            {accountTypes?.length > 0 ? (
              <div className='flex flex-wrap justify-center items-center gap-8 mx-auto'>
                {
                  accountTypes?.map((account, index) => (
                    <AccountCard key={index} account={account} handleSubmit={createAccount} type='live' />
                  ))
                }
              </div>
            ) : (
              <div>
                <p className='text-gray-400 text-center my-14'>No account found for this user.</p>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Open live account form modal */}
      <ModalComponent isOpen={isOpenLiveForm} setIsOpen={setIsOpenLiveForm} title='Open Live Account'>
        <Form className='w-full' autoComplete="off" form={form} initialValues={liveInitialValues} onFinish={handleLiveAccount}>
          <div className='ant-select-selector-white'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Leverage</label>
            <Form.Item name='leverage' rules={[{ required: true, message: 'Please select leverage.' }]}>
              <Select className='border-primary w-full mt-1' placeholder='Select leverage' options={v2fxOptions} />
            </Form.Item>
          </div>
          <div className='flex justify-center items-center gap-5 mt-10'>
            <button type='button' disabled={isLiveFormLoading} className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500' onClick={() => setIsOpenLiveForm(false)}>Cancel</button>
            <LoadableButton
              className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
              disabled={isLiveFormLoading}
              type="Submit"
              lable='Proceed'
              isLoading={isLiveFormLoading}
              loadingLable='Opening Live Account...'
            />
          </div>
        </Form>
      </ModalComponent>
    </div>
  )
}